document.addEventListener('DOMContentLoaded', function () {
  var pills = document.querySelectorAll('.ms-shop .ms-filter-pill');
  var sections = document.querySelectorAll('.ms-shop .ms-product-section');

  function filterProducts(category) {
    sections.forEach(function (section) {
      var sectionCat = section.getAttribute('data-category');
      if (category === 'all' || sectionCat === category) {
        section.style.display = 'block';
      } else {
        section.style.display = 'none';
      }
    });
  }

  pills.forEach(function (pill) {
    pill.addEventListener('click', function () {
      pills.forEach(function (p) { p.classList.remove('ms-filter-pill--active'); });
      pill.classList.add('ms-filter-pill--active');
      var cat = pill.getAttribute('data-filter');
      filterProducts(cat);
    });
  });
});
